import { oneOf, string, bool } from 'prop-types';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import DSPContentLoader from './TableControls/ContentLoader';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import Table from 'components/data-visualization/Table/Table';
import { Head, Label } from 'components/data-visualization/Table/SortingHead';
import Row from 'components/data-visualization/Table/Row';
import TableBody from 'components/data-visualization/Table/Body';

import useMedia from 'hooks/useMedia';

import {
  Header,
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';

function SkeletonLoader(props) {
  const { title, variation, productType, short } = props;
  const isLargeScreen = useMedia('(min-width: 60em)');
  const columnCount =
    variation === 'currentPosition'
      ? productType
        ? 6
        : 5
      : productType
      ? 5
      : 4;

  return (
    <GenericComponent
      title={title}
      loading={true}
      success={false}
      showToolbarDropdown={false}
      isNarrowScreen
      short={short}
    >
      <AnimatedLoadingWrapper loading={true}>
        <DSPContentLoader isLargeScreen={isLargeScreen} />

        <Table cellSpacing="0" cellPadding="0">
          {isLargeScreen && (
            <Head>
              <Row>
                <Header textAlign="center">
                  <Label>Position</Label>
                </Header>
                {productType && (
                  <Header>
                    <Label>{productType.label || null} name</Label>
                  </Header>
                )}
                <Header>
                  <Label>chart name</Label>
                </Header>
                <Header textAlign="right">
                  <Label>Territories</Label>
                </Header>
                {variation === 'currentPosition' && (
                  <Header textAlign="right">
                    <Label>Total streams</Label>
                  </Header>
                )}
                <Header />
              </Row>
            </Head>
          )}
          <TableBody>
            <TableLoader
              columnCount={columnCount}
              rowComponent={TableRow}
              cellComponent={TableCell}
            />
          </TableBody>
        </Table>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
}

SkeletonLoader.propTypes = {
  title: string.isRequired,
  productType: oneOf(['album', 'track']),
  variation: oneOf(['currentPosition', 'peakPosition']).isRequired,
  short: bool,
};

export default SkeletonLoader;
